import type { MoveToFolderMenuStore, NewFolderViewState } from "owa-mail-moveto-control-types";
import { createStore } from "owa-satcheljs";
import { MAIN_WINDOW_ID } from "../utils/constants";

export const initialStore: MoveToFolderMenuStore = {
    findTextMap: new Map<string, string>([[MAIN_WINDOW_ID, ""]]),
    isFocusInSearchBox: false,
    newFolderViewStateMap: new Map<string, NewFolderViewState | null>([[MAIN_WINDOW_ID, null]]),
    shouldShowAllFolders: false,
    moveToMailboxType: "UserMailbox",
    moveToSharedFolderRootId: "",
};

const getStore: () => MoveToFolderMenuStore = createStore<MoveToFolderMenuStore>("moveToStore", {
    ...initialStore,
});
export { getStore };
export default getStore;
